export const ADD_TO_BASKET_CTA = 'Add to basket';
export const ADDING_TO_BASKET_CTA = 'Adding';
export const BUY_GIFT_CARD_CTA = 'Buy giftcard';
export const EDIT_PERSONALISATION_CTA = 'Save changes';
export const SAVING_PERSONALISATION_CTA = 'Saving';
